import generalSection from "../_section/section.class";
import {userLoanStatementUpload, adminLoanStatementUpload} from "./upload";
import DataForm from "./DataForm";
import problem from "../_section/section-problem.class";
import ApplicationForm from "./ApplicationForm";
import {Figures} from "./Figures";
import dayjs from "dayjs";

export class userLoanStatementSection extends generalSection {
    constructor(request, mortgage, props, statementUploadFactory = null) {
        super(request, mortgage, props, statementUploadFactory ?? userLoanStatementUpload);
        // Add missing date error

    }
}

export class adminLoanStatementSection extends userLoanStatementSection {
    constructor(request, mortgage, props) {
        super(request, mortgage, props, adminLoanStatementUpload);
        this.ApplicationForm = ApplicationForm
        this.DataForm = DataForm

        this.sortByDateProp('endDate')
        this.setUploadsRanges(
            (() => {
                const activeUploads = [...this.uploads].reverse().filter(it => it.isActive && it.isVerifiable);
                return activeUploads.flatMap((upload, uploadIndex) => {
                    if (!upload?.dateData?.range?.ok) {
                        // console.log(`Upload ${upload.id} does not have a valid date range, skipping...`, upload);
                        return [];
                    }
                    const nextUploadWithOpening = activeUploads.find((it, i) => i > uploadIndex && it?.dateData?.range?.from?.date);
                    const openingDateOfNextUpload = nextUploadWithOpening ? nextUploadWithOpening?.dateData?.range?.from?.date : null;
                    // if there are start or end props available, use them, as they are the dates on the alignment endDate/startDate
                    let thisEnd = upload?.dateData?.range?.to
                    let thisStart = upload?.dateData?.range?.from


                    // this now updates the current upload end date, if the next upload opening date is before it
                    if (thisEnd?.date && openingDateOfNextUpload && openingDateOfNextUpload.isBefore(thisEnd.date)) {
                        let neededEndDate = openingDateOfNextUpload

                        thisEnd = {
                            date: neededEndDate,
                            balance: null // to detect if null to make error later!
                        }

                    }

                    return [
                        {
                            start: thisStart,
                            end: thisEnd,
                            uploadId: upload.id,
                        }
                    ]
                })
            })()
        )
        this.setProblems(this.getProblems());
    }

    Figures() {
        return new Figures({section: this});
    }

    getProblems() {

        const problems = this.problemsList.universalVerifiedUploadProblems();
        if (!problems.length) {

            if (this.data?.debtType) {
                if (!this.data?.isClosed) {
                    const acceptableDate = this.statementAlignmentDate ? this.statementAlignmentDate.clone().subtract(1, 'months') : dayjs().subtract(2, 'month').startOf('month',).subtract(1, 'day');
                    const mostRecentStatementDate = this.endDate
                    if (mostRecentStatementDate && mostRecentStatementDate.isBefore(acceptableDate)) {

                        return [
                            new problem({
                                type: 'BUNDLE',
                                title: 'Statement too old',
                                message: `Need a new statement dated after ${acceptableDate.format('DD MMM YYYY')}`,
                                uploadIDs: this.uploads.map(u => u.id),
                            }),
                            new problem({
                                type: 'USER_ALERT',
                                enum: 'MORE_LOAN_STATEMENTS_NEEDED',
                                title: 'Recent Loan Statement Needed',
                                uploadIDs: this.uploads.map(u => u.id),
                                body: `Upload a new statement dated after ${acceptableDate.format('DD MMM YYYY')}`,
                            })
                        ]
                    }
                }
                const iban = this.data?.accountNumber
                if (!iban) {
                    return [
                        new problem({
                            type: "BUNDLE",
                            title: 'Account No not set',
                            message: 'Account No missing from application',
                        })
                    ]
                }
            }
            // create a promblem if the newest statement is older than 2 months from the statement alignment date (or today if no alignment date)


            //problems.push(...this.problemsList.summaryRangeTooShort(6, 'months'))
            // if (this.statementAlignmentDate) {
            //     const expandedRange = this.calcExpandedRange(this.statementAlignmentDate.add(1,'day').subtract(6, 'months'), this.statementAlignmentDate);
            //     problems.push(...this.problemsList.missingInExpandedRange(expandedRange))
            // }
        }
        return problems
    }

    get endDate() {
        return this.uploads[0]?.values?.endDate || null;
    }

    get monthlyPayment() {
        return this.uploads[0]?.values?.monthlyPayment || null;
    }

    get outstandingBalanceUpload() {
        const mostRecentStatement = this._sortVerifiableUploads('endDate')[0]
        return {
            uploadID: mostRecentStatement?.id,
            amount: mostRecentStatement?.values?.closingBalance ? Math.abs(mostRecentStatement?.values?.closingBalance) || null : null,
        };
    }

    getSectionSummary = () => {
        const mostRecentStatement = this._sortVerifiableUploads('endDate')[0]

        if (mostRecentStatement) {
            return [
                {
                    name: this.personalTitle,
                    tags: [
                        {
                            name: 'End Date',
                            value: mostRecentStatement?.values?.endDate?.format('D MMM YYYY') || 'Not Provided'
                        },
                        {
                            name: 'Monthly Payment',
                            value: mostRecentStatement?.values?.monthlyPayment ? mostRecentStatement.values.monthlyPayment.toLocaleString() : 'Not Provided'
                        },
                        {
                            name: 'Balance',
                            value: mostRecentStatement?.values?.balance ? mostRecentStatement.values.balance.toLocaleString() : 'Not Provided'
                        }
                    ]
                }
            ]
        }
        return []

    }

}